export class CurrentUser {

	UserName: string;
	AppUserId: number;
	UserId: string;
	TenantId: number;
	SessionId: string;
	TokenType: string;
	Storage: string;
	AppRoles: string[];

	get appRoles(): string[] {
		return this.AppRoles || [''];
	}

	
	//Getters are used because when the object is populated from the token, they are ProperCase instead of javaCase
	get userName() { return this.UserName; }

	get appUserId() { return this.AppUserId; }

	get userId() { return this.UserId; }

	get tenantId() { return this.TenantId; }


}